export const DISPLAY_TYPE_LIST = 'list';
export const DISPLAY_TYPE_TILE = 'tile';
export const DISPLAY_TYPE_MINIMAL = 'minimal';

export type DisplayType = typeof DISPLAY_TYPE_LIST | typeof DISPLAY_TYPE_TILE | typeof DISPLAY_TYPE_MINIMAL;
